import { Button, Col, Modal, Row, Space, Typography } from "antd";
import { birthday2Age, convertIosStringToDate2 } from "helper/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { FORMAT_TIME } from "types/enums";
import BoxBHYT from "pages/Pay/PayTab/ModalPrintPTT/BoxBHYT/BoxBHYT";
import { Sign } from "components/common/PrintForm";
import { sharedDirectory } from "api";
import TextWithEllipsis from "helper/create-docs-to-form";
import DotFilledRow from "helper/create-docs-to-form";
import "./PhieuTienPhau.scss";
import dayjs from "dayjs";

const PhieuTienPhauPrint = React.forwardRef((props: any, ref) => {
  const tienPhauRef = useRef<any>();
  const [dataPhieu, setDataPhieu] = useState<any>(null);
  const [dataPhieuTienPhau, setDataPhieuTienPhau] = useState<any>(null);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setDataPhieu: setDataPhieu,
    setDataPhieuTienPhau: setDataPhieuTienPhau,
    setIsView: setIsView,
  }));

  const handleSave = async () => {
    const data = {
      by: localStorage.getItem("fullName"),
      suLanCuoi: dayjs(),
    };
    await props.onSave(1, data);
    closeModal();
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const onPrint = async () => {
    window.print();
  };
  // const style = {
  //   fontFamily: '"Times New Roman", Times, serif',
  // };
  useEffect(() => {}, [isModalOpen]);
  const [danToc, setDanToc] = useState([]);
  const getListDanToc = async () => {
    try {
      let response = await sharedDirectory.getListDanToc();
      setDanToc(response.data.data);
    } catch (err) {}
  };

  useEffect(() => {
    getListDanToc();
  }, []);
  const handleRemoveDots = (dots: string, value: string) => {
    if (value) {
      //Tách chuỗi
      const newValue = value.split("");
      //Loại bỏ số phần tử ...... bằng với độ dài của chuỗi đã cắt
      const removeDots = dots.slice(newValue.length + 7);
      const joinString = newValue.join("").concat(removeDots);
      return joinString;
    } else return dots;
  };

  return (
    <div className="phieu-tien-phau">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={960}
        destroyOnClose={true}
      >
        <div ref={tienPhauRef} className="print-content-phieu-tien-phau">
          <Row
            style={{
              padding: "20px 20px 25px 2.2cm",
              lineHeight: 1.5,
            }}
          >
            <Row>
              <Row justify={"space-between"}>
                <Col span={11}>
                  <Row
                    justify={"center"}
                    style={{
                      fontWeight: "bold",
                      fontSize: "12pt",
                      // fontFamily: style.fontFamily,
                    }}
                  >
                    BỘ Y TẾ
                  </Row>

                  <Row
                    style={{
                      fontWeight: "bold",
                      fontSize: "12pt",
                      // fontFamily: style.fontFamily,
                    }}
                    justify={"center"}
                  >
                    BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                  </Row>
                </Col>
                <Col span={8}></Col>
                <Col flex={"auto"}>
                  <Row>Ngày: {moment().format(FORMAT_TIME.dayFull)}</Row>
                  <Row>Số NV:</Row>
                </Col>
              </Row>
              <Row
                justify={"center"}
                style={{
                  fontWeight: "bold",
                  padding: "12px 10px 0px 10px",
                  fontSize: "24px",
                }}
              >
                <Row style={{ fontSize: "24px" }} justify={"center"}>
                  PHIẾU KHÁM TIỀN PHẪU
                </Row>
              </Row>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr style={{ height: "10px" }}></tr>
                </thead>
                <tbody>
                  <Row>
                    Họ tên người bệnh:
                    <span style={{ fontWeight: "bold", paddingLeft: "5px" }}>
                      {dataPhieu?.tenBenhNhan?.toUpperCase()}
                    </span>
                  </Row>
                  <Row>
                    <Col flex={"auto"}>
                      Tuổi: {birthday2Age(dataPhieu?.ngaySinh)}
                    </Col>
                    <Col span={12}>
                      <Row align={"middle"}>
                        Giới tính:{" "}
                        {dataPhieu?.gioiTinh === 0
                          ? "Nam"
                          : dataPhieu?.gioiTinh === 1
                          ? "Nữ"
                          : ""}
                      </Row>
                    </Col>
                  </Row>

                  <Row>Địa chỉ: {dataPhieu?.diaChi}</Row>
                  <Row style={{ paddingBottom: "10px" }}>
                    <Col span={3}>Chẩn đoán:</Col>
                    <Col flex={"auto"}>
                      <Row>
                        {dataPhieu?.idChanDoan ?? ""} -{" "}
                        {dataPhieu?.chanDoan ?? ""}
                      </Row>
                    </Col>
                  </Row>
                  <Space
                    style={{ width: "100%" }}
                    direction="vertical"
                    size={"small"}
                  >
                    <Row style={{ border: "1px solid" }}>
                      <div style={{ padding: "5px", width: "100%" }}>
                        <Typography.Text strong>Tiền sử bệnh</Typography.Text>
                        <Row>
                          <Col span={2}>Dị ứng</Col>
                          <Col flex={"auto"} style={{ paddingRight: "10px" }}>
                            <Row justify={"space-around"}>
                              <span>Không&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.diUng?.khong}
                                />
                                <span></span>
                              </label>
                              <span>Có&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.diUng?.co}
                                />
                                <span></span>
                              </label>
                              <span>Thức ăn&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.diUng?.thucAn}
                                />
                                <span></span>
                              </label>
                              <span>Thuốc&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.diUng?.thuoc}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={4}>
                            Loại:{" "}
                            {handleRemoveDots(
                              "..............",
                              dataPhieuTienPhau?.loai
                            )}
                          </Col>
                        </Row>
                        <Row>
                          Tim mạch:{" "}
                          {handleRemoveDots(
                            ".......................................................................................................................................................",
                            dataPhieuTienPhau?.timMach
                          )}
                        </Row>
                        <Row>
                          <Col span={12}>
                            Huyết áp:{" "}
                            {handleRemoveDots(
                              "..............................................................",
                              dataPhieuTienPhau?.ha
                            )}
                          </Col>
                          <Col span={12}>
                            Thuốc HA:{" "}
                            {handleRemoveDots(
                              "..............................................................",
                              dataPhieuTienPhau?.thuocHA
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            Tiểu đường:{" "}
                            {handleRemoveDots(
                              "..............................................................",
                              dataPhieuTienPhau?.td
                            )}
                          </Col>
                          <Col span={12}>
                            Thuốc tiểu đường:{" "}
                            {handleRemoveDots(
                              "..................................................",
                              dataPhieuTienPhau?.thuoctd
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col span={4}>Hô hấp: </Col>
                          <Col span={12} style={{ paddingRight: "10px" }}>
                            <Row justify={"space-around"}>
                              Suyễn:
                              <span>Không&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.hoHap?.khong}
                                />
                                <span></span>
                              </label>
                              <span>Có&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.hoHap?.co}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={8}>
                            Cơn gần nhất:{" "}
                            {handleRemoveDots(
                              ".............................",
                              dataPhieuTienPhau?.conGanNhat
                            )}
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "5px" }}>
                          <Col span={4}>Tiêu hóa: </Col>
                          <Col span={12} style={{ paddingRight: "10px" }}>
                            <Row justify={"space-around"}>
                              Nôn ói:
                              <span>Không&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.tieuHoa?.khong}
                                />

                                <span></span>
                              </label>
                              <span>Có&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.tieuHoa?.co}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={8}>
                            Thuốc trị:{" "}
                            {handleRemoveDots(
                              "....................................",
                              dataPhieuTienPhau?.thuocTri
                            )}
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "5px" }}>
                          <Col span={4}>Phẫu thuật: </Col>
                          <Col span={12} style={{ paddingRight: "10px" }}>
                            <Row justify={"space-around"}>
                              <span style={{ width: "46px" }}></span>
                              <span>Không&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.pt?.khong}
                                />
                                <span></span>
                              </label>
                              <span>Có&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.pt?.co}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={8}></Col>
                        </Row>
                        <Row>
                          Bệnh khác:{" "}
                          {handleRemoveDots(
                            "..................................................................................................................................................",
                            dataPhieuTienPhau?.benhkhac
                          )}
                        </Row>
                        <Row style={{ paddingBottom: "10px" }}>
                          Đang dùng thuốc:{" "}
                          {handleRemoveDots(
                            ".......................................................................................................................................",
                            dataPhieuTienPhau?.dangDungThuoc
                          )}
                        </Row>
                      </div>
                    </Row>
                    {/*  */}
                    {/* Khám lâm sàng */}
                    <Row style={{ border: "1px solid" }}>
                      <div style={{ padding: "5px", width: "100%" }}>
                        <Typography.Text strong>Khám lâm sàng</Typography.Text>
                        <Row justify={"space-between"} gutter={[16, 35]}>
                          <Col span={6}>
                            <Row>
                              <Col>
                                M:{" "}
                                {handleRemoveDots(
                                  "...................",
                                  dataPhieuTienPhau?.kls?.m
                                )}
                              </Col>
                              <Col>lần/phút</Col>
                            </Row>
                          </Col>
                          <Col span={8}>
                            <Row>
                              <Col>
                                HA:{" "}
                                {handleRemoveDots(
                                  "...........................",
                                  dataPhieuTienPhau?.kls?.ha
                                )}
                              </Col>
                              <Col>mmHg</Col>
                            </Row>
                          </Col>
                          <Col span={8}>
                            <Row>
                              <Col>
                                NT:{" "}
                                {handleRemoveDots(
                                  "......................",
                                  dataPhieuTienPhau?.kls?.nt
                                )}
                              </Col>
                              <Col>lần/phút</Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ height: "14px" }}></Row>
                        <Row justify={"space-between"}>
                          <Col span={10}>
                            <Row justify={"space-between"}>
                              <Typography>Tim</Typography>
                              <Typography>Đều</Typography>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.tim?.deu}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <Row>
                              <span style={{ width: "100px" }}>Khác&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.tim?.khac}
                                />
                                <span></span>
                              </label>
                              {handleRemoveDots(
                                "....................................",
                                dataPhieuTienPhau?.tim?.note
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Row justify={"space-between"}>
                          <Col span={10}>
                            <Row justify={"space-between"}>
                              <Typography>Phổi</Typography>
                              <Typography>Trong</Typography>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.phoi?.trong}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <Row>
                              <span style={{ width: "100px" }}>Khác&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.phoi?.khac}
                                />
                                <span></span>
                              </label>
                              {handleRemoveDots(
                                "....................................",
                                dataPhieuTienPhau?.phoi?.note
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ paddingBottom: "10px" }}></Row>
                      </div>
                    </Row>
                    {/*  */}
                    {/*  Xét nghiệm CLS*/}
                    <Row style={{ border: "1px solid" }}>
                      <div style={{ padding: "5px", width: "100%" }}>
                        <Typography.Text strong>Xét nghiệm CLS</Typography.Text>

                        <Row justify={"space-between"}>
                          <Col span={10}>
                            <Row justify={"space-between"}>
                              <Typography>CTM</Typography>
                              <Typography>Bình thường</Typography>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.ctm?.binhThuong}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <Row>
                              <span style={{ width: "100px" }}>Khác&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.ctm?.khac}
                                />
                                <span></span>
                              </label>
                              {handleRemoveDots(
                                "....................................",
                                dataPhieuTienPhau?.ctm?.note
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Row justify={"space-between"}>
                          <Col span={10}>
                            <Row justify={"space-between"}>
                              <Typography>ECG</Typography>
                              <Typography>Bình thường</Typography>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.ecg?.binhThuong}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <Row>
                              <span style={{ width: "100px" }}>Khác&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.ecg?.khac}
                                />
                                <span></span>
                              </label>
                              {handleRemoveDots(
                                "....................................",
                                dataPhieuTienPhau?.ecg?.note
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Row justify={"space-between"}>
                          <Col span={10}>
                            <Row justify={"space-between"}>
                              <Typography>Xét nghiệm máu</Typography>
                              <Typography>Bình thường</Typography>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.xnm?.binhThuong}
                                />
                                <span></span>
                              </label>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <Row>
                              <span style={{ width: "100px" }}>Khác&nbsp;</span>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={dataPhieuTienPhau?.xnm?.khac}
                                />
                                <span></span>
                              </label>
                              {handleRemoveDots(
                                "....................................",
                                dataPhieuTienPhau?.ecg?.note
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ paddingBottom: "10px" }}></Row>
                      </div>
                    </Row>
                    <Row>
                      <Col span={5}>Tình trạng ASA</Col>
                      <Col span={10}>
                        <Row style={{ gap: "1px" }}>
                          <label className="custom-checkbox value1">
                            <input type="checkbox" checked={true} />
                            <span></span>
                          </label>
                          <label className="custom-checkbox value2">
                            <input type="checkbox" checked={true} />
                            <span></span>
                          </label>
                          <label className="custom-checkbox value3">
                            <input type="checkbox" checked={true} />
                            <span></span>
                          </label>
                          <label className="custom-checkbox value4">
                            <input type="checkbox" checked={true} />
                            <span></span>
                          </label>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      Bệnh nhân có mổ với phương pháp vô cảm:
                      <Row justify={"space-around"}>
                        <Col span={4}>
                          <Row justify={"space-between"}>
                            <span>Nhỏ tê&nbsp;</span>
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                checked={dataPhieuTienPhau?.nhoTe}
                              />
                              <span></span>
                            </label>
                          </Row>
                        </Col>
                        <Col span={4}>
                          <Row justify={"space-between"}>
                            <span>Chích tê&nbsp;</span>
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                checked={dataPhieuTienPhau?.chich}
                              />
                              <span></span>
                            </label>
                          </Row>
                        </Col>
                        <Col span={4}>
                          <Row justify={"space-between"}>
                            <span>Mê&nbsp;</span>
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                checked={dataPhieuTienPhau?.me}
                              />
                              <span></span>
                            </label>
                          </Row>
                        </Col>
                      </Row>
                    </Row>
                    <Row>
                      Điều lưu ý:{" "}
                      {handleRemoveDots(
                        "........................................................................................................................................................",
                        dataPhieuTienPhau?.dieuLuuy
                      )}
                    </Row>
                  </Space>
                </tbody>
                <tfoot>
                  <tr style={{ height: "10px" }}></tr>
                </tfoot>
              </table>
              <Row justify={"space-around"}>
                <Col span={16}>
                  Ngày khám: {dayjs().format(FORMAT_TIME.dayFull)}
                </Col>
                <Col flex={"auto"}>
                  <Row justify={"center"}>Bác sĩ khám</Row>
                  <Row
                    justify={"center"}
                    style={{ fontStyle: "italic", fontSize: "13px" }}
                  >
                    (Ký và ghi rõ họ tên)
                  </Row>
                </Col>
              </Row>
            </Row>
          </Row>
        </div>

        <Row justify={"end"} gutter={[16, 16]} style={{ paddingTop: "10px" }}>
          {/* <Space direction="horizontal"> */}
          <Col>
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
          </Col>
          {isView ? (
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    In
                  </Button>
                );
              }}
              content={() => tienPhauRef.current}
              bodyClass="print-content-phieu-vao-vien"
              // onAfterPrint={closeModal}
            />
          ) : (
            <Button type="primary" onClick={handleSave}>
              Lưu
            </Button>
          )}
        </Row>
      </Modal>
    </div>
  );
});

export default PhieuTienPhauPrint;
